import { styled as o, Box as c, Typography as a } from "@mui/material";
import { useFrontendConfigContext as k } from "../../config-lib/contexts/FrontendConfigContext.js";
import "../../config-lib/deserializes/yup/config.js";
import "../../config-lib/graphql/getFrontendConfig.js";
import "@apollo/client";
import "../../apostle-lib/deserializes/yup/apostle.js";
import "react";
import * as s from "ramda";
import "../../temp-lib/util/i18n/helper/locale.js";
import { useTranslation as T, Trans as B } from "react-i18next";
import { CurrencyTokenType as P } from "../../currency-lib/constants/currency.js";
import { useCurrencyContext as v } from "../../currency-lib/contexts/CurrencyContext.js";
import "../../currency-lib/deserialize/yup/currency.js";
import "../../currency-lib/graphql/query/getCurrencyInfo.js";
import "../../currency-lib/graphql/query/getOffChainTokenBalances.js";
import "../../currency-lib/hooks/graphql/useGetTokenPriceToUSD.js";
import "../../temp-lib/styles/theme.js";
import { jsxs as m, jsx as t } from "react/jsx-runtime";
import "../../temp-lib/legacy/header/Header.js";
import "../../temp-lib/legacy/infoAccordion/InfoAccordion.js";
import "../../temp-lib/legacy/layout/Layout.js";
import "../../temp-lib/legacy/nav/Nav.js";
import "@metamask/detect-provider";
import "../../temp-lib/legacy/util/provider/Web3Instance.js";
import "jsonwebtoken";
import "web3";
import "../../temp-lib/legacy/util/provider/WalletConnect.js";
import "../../download-lib/deserializes/yup/download.js";
import "../../temp-lib/components/account/adeptus/AdeptusCodeInput.js";
import "../../temp-lib/components/account/adeptus/AdeptusSuccessPopup.js";
import "../../temp-lib/components/account/share/ConfirmButton.js";
import "../../temp-lib/components/account/share/FormControlledPassword.js";
import "i18next";
import "../../temp-lib/components/account/share/EmailOTPSender.js";
import "../../temp-lib/components/share/mui/Textfield.js";
import "react-hook-form";
import "../../temp-lib/components/account/share/ForgotPasswordButton.js";
import "../../temp-lib/components/account/share/PopupTitle.js";
import "../../temp-lib/components/account/share/SendEmailOTPButton.js";
import "../../temp-lib/components/footer/Footer.js";
import "../../temp-lib/components/role/EnoughRoleOnly.js";
import "../../temp-lib/components/share/apeiron/ApeironBlueButton.js";
import "../../temp-lib/components/share/apeiron/ApeironButtonDisableTip.js";
import "../../temp-lib/components/share/apeiron/ApeironChickenPopup.js";
import "../../temp-lib/components/share/apeiron/ApeironCloseButton.js";
import "../../temp-lib/components/share/apeiron/ApeironCookieConsent.js";
import "../../temp-lib/components/share/apeiron/ApeironEllipsisTypography.js";
import "../../temp-lib/components/share/apeiron/ApeironGoToButton.js";
import "../../temp-lib/components/share/apeiron/ApeironImageButton.js";
import "../../temp-lib/components/share/apeiron/ApeironInfinityDataGrid.js";
import "../../temp-lib/components/share/apeiron/ApeironLinkButton.js";
import "../../temp-lib/components/share/apeiron/ApeironLoopVideo.js";
import "../../temp-lib/components/share/apeiron/ApeironPagingDataGrid.js";
import "../../temp-lib/components/share/apeiron/ApeironReactPlayer.js";
import "../../temp-lib/components/share/apeiron/ApeironSectionTitle.js";
import "../../temp-lib/components/share/apeiron/ApeironTitle.js";
import "../../temp-lib/components/share/apeiron/ApeironTutorialDialog/ApeironTutorialDialog.js";
import "../../temp-lib/components/share/generic/CloseButton.js";
import I from "../../temp-lib/components/share/generic/IconText.js";
import "../../temp-lib/components/share/generic/ModalBox.js";
import "../../temp-lib/components/share/generic/Pagination.js";
import "../../temp-lib/components/share/generic/SearchEmptyState.js";
import "../../temp-lib/components/share/generic/Skeleton.js";
import "../../temp-lib/components/share/generic/TextInput.js";
import "next/script";
import "../../temp-lib/components/share/mui/Snackbar.js";
import "../../temp-lib/components/share/next/Image.js";
import "../../temp-lib/components/share/next/NextLink.js";
import j from "../../temp-lib/components/share/popup/InfoPopup.js";
import "../../temp-lib/constants/account.js";
import "../../temp-lib/constants/googleAnalytics.js";
import { INFO_POPUP_TYPE as L } from "../../temp-lib/constants/popup.js";
import "../../temp-lib/constants/query.js";
import "../../temp-lib/contexts/account/AccountContext.js";
import "../../temp-lib/contexts/account/Geetest4Context.js";
import "../../temp-lib/contexts/adeptus/AdeptusContext.js";
import "@apollo/client/link/error";
import "@apollo/client/utilities";
import "../../temp-lib/contexts/config/ConfigContext.js";
import "../../temp-lib/contexts/language/LanguageContext.js";
import "path";
import "query-string";
import "p-retry";
import "ramda-adjunct";
import "../../temp-lib/contexts/share/LogicControlContext.js";
import "../../temp-lib/contexts/fingerprint/FingerprintContext.js";
import "../../temp-lib/contexts/role/RoleContext.js";
import "../../temp-lib/contexts/share/DataGridContext.js";
import "../../temp-lib/contexts/share/MessageContext.js";
import "../../temp-lib/contexts/share/PersistQueryContext.js";
import "../../temp-lib/contexts/share/PreloadContext.js";
import "@tanstack/react-query";
import "../../temp-lib/contexts/share/ScreenLogContext.js";
import "../../temp-lib/contexts/web3/Web3Context.js";
import "../../wallet-lib/contexts/RoninNameServiceContext.js";
import "../../temp-lib/deserialize/yup/account.js";
import "../../temp-lib/deserialize/yup/chain.js";
import "../../temp-lib/deserialize/yup/locale.js";
import "../../temp-lib/deserialize/yup/page.js";
import "../../temp-lib/deserialize/yup/platform.js";
import "../../temp-lib/graphql/fragment/account.js";
import "date-fns";
import "date-fns/constants";
import "react-countdown";
import "next/router";
import "@walletconnect/utils";
import "@wagmi/core";
import "../../temp-lib/util/query/index.js";
import "../../temp-lib/deserialize/yup/adeptusCampaign.js";
import "../../temp-lib/graphql/query/getAdeptusCampaigns.js";
import "../../temp-lib/graphql/query/getPublicAccountDetail.js";
import "../../temp-lib/graphql/mutation/processEmailRegister.js";
import "../../temp-lib/util/erc20/index.js";
import "viem";
import "i18next-http-backend";
import "react-i18next/initReactI18next";
import "../../temp-lib/util/misc/formatNumberString.js";
import "../../temp-lib/util/yup/index.js";
import "../../temp-lib/wagmi/roninConnector.js";
const R = o(j)`
  background: unset;
  background-color: unset;

  max-height: 95vh;
  max-width: 95vw;

  .Custom-Content {
    border-radius: 8px;
    background-color: rgba(39, 40, 42, 0.95);
    padding: 10px;
    overflow: auto;

    > *:first-of-type {
      border-bottom: none;
    }

    > *:last-of-type {
      border-bottom: none;
    }
  }
`, f = o(c)`
  border-bottom: 0.25px solid #cccccccc;
  display: flex;

  > *:last-of-type {
    border-right: none;
  }

  ${(r) => r.theme.breakpoints.up("res1024")} {
    width: 1200px;
  }
  ${(r) => r.theme.breakpoints.between("res480", "res1024")} {
    width: 1000px;
  }
  ${(r) => r.theme.breakpoints.down("res480")} {
    width: 800px;
  }
`, A = o(c)`
  display: flex;
  flex-direction: column;
  flex: 6;
`, F = o(c)`
  display: flex;
  width: 100%;
`, l = o(a)`
  align-items: center;
  border-right: 0.25px solid #cccccc33;
  display: flex;
  flex: 1;
  letter-spacing: 0.25px;
  justify-content: center;
  height: 66px;
`, u = o(l)`
  background-color: white;
  color: black;
`, G = o(u)`
  font-weight: 500;
`, H = o(G)`
  height: 56px;
`, S = o(l)`
  background-color: #d3d3d3;
  color: black;
`, W = o(S)`
  font-weight: 500;
`, _ = o(W)`
  height: 56px;
`, $ = o(l)`
  background-color: #282828;
  color: white;
`, O = o($)`
  font-weight: 500;
`, z = o(l)`
  background-color: #e6e0f4;
  color: black;
`, E = o(c)`
  align-items: center;
  background-color: #5e16ff;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
`, K = o(a)`
  font-weight: 300;
`, M = o(I)`
  .Custom-Icon {
    width: 16px;
  }
  .Custom-Text {
    font-size: 14px;
  }
`, N = o(a)`
  background-color: #dc6345;
  padding: 5px 0px;
  text-align: center;
  width: 100%;

  strong {
    color: #00ecda;
    font-weight: 500;
    text-decoration: underline;
  }
`, rr = (r) => {
  const {
    open: b,
    onClose: g
  } = r, {
    config: d
  } = k(), {
    getCurrency: y
  } = v(), {
    t: e
  } = T(), i = d == null ? void 0 : d.vipLevel.aprTable, p = y(P.Aprs);
  return /* @__PURE__ */ m(R, {
    type: L.BLACK,
    open: b,
    onClose: g,
    children: [/* @__PURE__ */ m(f, {
      children: [/* @__PURE__ */ m(A, {
        children: [/* @__PURE__ */ m(F, {
          children: [/* @__PURE__ */ t(_, {
            children: e("apr.vip")
          }), s.map((n) => /* @__PURE__ */ t(H, {
            children: e("common.i18n_format.day", {
              count: n
            })
          }, n), (i == null ? void 0 : i.duration) || [])]
        }), /* @__PURE__ */ t(N, {
          children: /* @__PURE__ */ t(B, {
            children: e("apr.hint")
          })
        })]
      }), /* @__PURE__ */ m(E, {
        children: [/* @__PURE__ */ t(K, {
          children: e("apr.monthly")
        }), /* @__PURE__ */ t(M, {
          startSrc: (p == null ? void 0 : p.image) || "",
          text: (p == null ? void 0 : p.name) || ""
        })]
      })]
    }), s.map((n) => {
      const {
        level: h,
        rate: w,
        scaler: C
      } = n;
      return /* @__PURE__ */ m(f, {
        children: [/* @__PURE__ */ t(O, {
          children: h
        }), s.map((x) => /* @__PURE__ */ t(u, {
          children: x
        }, x), w), /* @__PURE__ */ t(z, {
          children: C
        })]
      }, h);
    }, (i == null ? void 0 : i.data) || [])]
  });
};
export {
  rr as default
};
//# sourceMappingURL=VipAprTable.js.map
